import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { salesPageData, isPlaceholder } from '../data/salesPageData';
interface FaqItem {
  q: string;
  a: string;
}
function buildFaqs(): FaqItem[] {
  const deliveryKnown = !isPlaceholder(salesPageData.deliveryMethod);
  const faqs: FaqItem[] = [{
    q: '¿Qué es La Bóveda del Carpintero?',
    a: 'Es una biblioteca digital de carpintería que reúne más de 500 planos, proyectos, medidas, diseños y recursos complementarios en un solo lugar.'
  }, {
    q: '¿Necesito experiencia en carpintería?',
    a: 'No. Dentro del contenido existe material pensado para personas que están empezando, incluyendo Carpintería Desde Cero.'
  }, {
    q: '¿Qué tipo de proyectos voy a encontrar?',
    a: 'Entre otras categorías, vas a encontrar muebles de TV, mesas, escritorios, repisas, cocinas, placares, organizadores, muebles de baño, proyectos de melamina y muebles industriales.'
  }, {
    q: '¿Es un producto físico?',
    a: 'No. La Bóveda del Carpintero es un producto 100% digital. No se envían libros físicos por correo.'
  }, {
    q: '¿Puedo ver el material desde el celular?',
    a: 'Sí. Podés consultar el material desde celular, tablet o computadora compatible.'
  }, {
    q: '¿Cuánto tiempo tengo acceso?',
    a: 'Según las condiciones actuales, el acceso no tiene fecha de vencimiento.'
  }, {
    q: '¿El pago es mensual?',
    a: 'No. Realizás un único pago. No existe suscripción mensual.'
  }, {
    q: '¿Cómo recibo el acceso?',
    a: deliveryKnown ? `Después de que se acredita el pago, recibís las instrucciones correspondientes mediante: ${salesPageData.deliveryMethod}` : 'Después de que se acredita el pago, recibís las instrucciones correspondientes para ingresar al material.'
  }, {
    q: '¿Puedo utilizar estos proyectos para fabricar muebles para clientes?',
    a: 'Podés utilizar el material como referencia para desarrollar tus propios proyectos y trabajos conforme a los términos de uso correspondientes.'
  }, {
    q: '¿Necesito herramientas profesionales?',
    a: 'Depende del proyecto. La biblioteca contiene alternativas de diferentes niveles y Carpintería Desde Cero ayuda a entender con qué herramientas comenzar.'
  }, {
    q: '¿Qué pasa si el producto no es para mí?',
    a: `Contás con una garantía de ${salesPageData.guaranteeDays} días conforme a las condiciones de devolución vigentes.`
  }];
  return faqs;
}
export function FAQSection() {
  const faqs = buildFaqs();
  const [open, setOpen] = useState<number | null>(0);
  return <section id="preguntas" className="border-t border-[#111111]/10 bg-[#EFEDE8] text-[#111111]" aria-labelledby="faq-title" data-id="element-59" data-mp="3czoncbe60e1j">
      <div className="mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-60" data-mp="3mrchwl60qb78">
        <div className="mx-auto max-w-3xl text-center" data-id="element-61" data-mp="3mqjbxmevvpq5">
          <p className="font-display text-[10px] font-extrabold uppercase tracking-[0.24em] text-[#E96800]" data-id="element-62" data-mp="3qtpdigr1wsqa">
            Antes de abrir la Bóveda
          </p>
          <h2 id="faq-title" className="reveal mt-4 font-display text-2xl font-black uppercase leading-[1.1] tracking-tight sm:text-4xl" data-id="element-63" data-mp="3vpo9apepld0q">
            Preguntas frecuentes
          </h2>
        </div>

        <ul className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-64" data-mp="1f7x59nmji3yk">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="overflow-hidden rounded-xl border border-[#111111]/10 bg-white" data-id="element-65" data-mp="165nvx130cgmr" data-mpi={i}>
                <h3 data-id="element-66" data-mp="22u3q5ah2be67">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left min-h-[56px] transition-colors hover:bg-[#F8F3EA]" data-id="element-67" data-mp="22un4yibf1mg0">
                    <span className="font-display text-sm font-extrabold uppercase leading-snug tracking-tight text-[#111111] sm:text-[15px]" data-id="element-68" data-mp="1p2p5z0bf56xk">
                      {faq.q}
                    </span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-[#111111]/5 text-[#E96800]" data-id="element-69" data-mp="2hreazaflhwel">
                      {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="21f11z9tklymz" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-71" data-mp="26c9jd86w9yn6" />}
                    </span>
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${i}`} className="border-t border-[#111111]/8 px-5 py-4 text-[15px] leading-relaxed text-[#111111]/70" data-id="element-72" data-mp="1sel20ac1d9mv">
                    {faq.a}
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}